<template>
  <div class="loginPage">
    <v-row dense no-gutters class="auth-row">
      <!-- LEFT: Account Type Select -->
      <v-col cols="12" sm="12" md="6" class="custom-height">
        <div class="auth-light-version">
          <div class="logo">
            <v-img :width="logoWidth" :height="logoHeight" :src="logoSrc"></v-img>
          </div>

          <h3>Create New Account</h3>

          <div class="wrapper-box">
            <v-card-text class="pa-0 account-type-title">
              Please Choose Your Account Type First
            </v-card-text>

            <div class="account-login-links">
              <!-- Individual -->
              <v-card :ripple="false" outlined tile class="widgets-card-reg" :class="{ selected: isIndividualSelected }"
                @click="selectAccountType(1)">
                <v-btn class="mx-2 mb-3" fab small elevation="0" color="#039de9">
                  <v-icon color="#fff">mdi-account-outline</v-icon>
                </v-btn>
                <p class="mb-0 type-text">Individual</p>
              </v-card>

              <!-- Company -->
              <v-card :ripple="false" outlined tile class="widgets-card-reg" :class="{ selected: isCompanySelected }"
                @click="selectAccountType(2)">
                <v-btn class="mx-2 mb-3" fab small elevation="0" color="#039de9">
                  <v-icon color="#fff">mdi-home-outline</v-icon>
                </v-btn>
                <p class="mb-0 type-text">Company</p>
              </v-card>
            </div>

            <v-btn class="mx-auto text-capitalize btn-account" color="#039de9" tile elevation="0" @click="nextPage"
              :disabled="!allConditionsMet">
              Next
            </v-btn>

            <div class="another-link">
              <p>
                Already have an account?
                <router-link to="/">Log in</router-link>
              </p>
            </div>
          </div>
        </div>
      </v-col>

      <!-- RIGHT: Content + Image -->
      <v-col cols="12" sm="12" md="6" class="image-col">
        <div class="image-content">
          <h3 class="mb-2">Turn Risk into Opportunity. Master the Market:</h3>
          <p>
            Great rewards are never born from comfort zones. High-risk markets
            are arenas for those who prepare relentlessly, think strategically,
            and act with discipline. Every challenge is a lesson, every move a
            chance to grow stronger and smarter. Stay focused, manage your risk
            wisely, and trust the power of informed decisions. When courage
            meets knowledge, potential becomes performance.
          </p>

          <social-icons :info="genInfo"></social-icons>
        </div>

        <div class="image-container">
          <v-img src="@/assets/auth.png" class="zoom-animate-full image-full"></v-img>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LanguageMenu from "@/components/TopBar/LanguageMenu.vue";
import { PUBLIC_LOGIN__ACTIONS } from "@/store/action-types";
import { mapActions, mapMutations, mapState } from "vuex";
import SocialIcons from "../auth/SocialIcons.vue";

export default {
  name: "CreateAccount",
  components: { LanguageMenu, SocialIcons },

  data() {
    return {
      genInfo: {},
    };
  },

  computed: {
    ...mapState("register", ["registerInfo"]),
    ...mapState("publicinfo", ["info"]),

    // ✅ Next button enable condition
    allConditionsMet() {
      return !!this.registerInfo?.owner_type;
    },

    // ✅ selection computed (only one selected at a time)
    isIndividualSelected() {
      return Number(this.registerInfo?.owner_type) === 1;
    },
    isCompanySelected() {
      return Number(this.registerInfo?.owner_type) === 2;
    },

    logoSrc() {
      return this.$vuetify.theme.light ? this.info?.logo_url : this.info?.logo_url_dark;
    },

    companyName() {
      return this.info?.company_name || "Forex Crm";
    },

    logoWidth() {
      return this.info?.logo_width || "50px";
    },

    logoHeight() {
      return this.info?.logo_height || "50px";
    },
  },

  methods: {
    ...mapMutations("register", ["REGISTER_ACCOUNT_TYPE", "RESET"]),
    ...mapActions("publicinfo", [PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO]),

    // ✅ click handler
    selectAccountType(type) {
      // keep only one selected at a time (no toggle off)
      this.REGISTER_ACCOUNT_TYPE(type === 1 ? "Individual" : "Company");
    },

    nextPage() {
      this.RESET();
      this.$router.push("/registration");
    },
  },

  async mounted() {
    // Load public info then sync genInfo
    await this[PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO]();
    this.genInfo = this.info || {};
    document.title = "Create Account";
  },

  created() {
    this.genInfo = this.info || {};
  },
};
</script>

<style scoped>
/* ✅ CARD BASE */
.widgets-card-reg {
  width: 170px;
  min-height: 150px !important;
  margin: 0 1rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  /* normal */
  border: 1px solid rgba(112, 138, 167, 0.6) !important;
  background: transparent !important;

  transition: all 0.25s ease;
}

/* ✅ TEXT DEFAULT */
.widgets-card-reg .type-text {
  font-weight: 500;
  color: #708aa7;
  transition: all 0.25s ease;
}

/* ✅ SELECTED STATE */
.widgets-card-reg.selected {
  border: 2px solid #039de9 !important;
  /* bold border */
  background: rgba(3, 157, 233, 0.12) !important;
  /* highlight bg (light/dark ok) */
}

.widgets-card-reg.selected .type-text {
  font-weight: 700;
  /* bold text */
  color: #039de9;
}

/* ✅ HOVER (optional nice touch) */
.widgets-card-reg:hover {
  transform: translateY(-2px);
  border-color: rgba(3, 157, 233, 0.9) !important;
}

.logo {
  margin-left: auto;
  margin-right: auto;
  width: fit-content;
}
</style>
